import { Component, OnInit } from '@angular/core';

import { selectors } from '@lbmx/app-state';
import { NavItem } from '@lbmx/types';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-main-navigation-container',
  templateUrl: './main-navigation-container.component.html',
})
export class MainNavigationContainerComponent implements OnInit {
  public allowedModules$: Observable<{ [key: string]: boolean }>;
  public navigationItems$: Observable<NavItem[]>;

  constructor(private store: Store) {}

  public ngOnInit() {
    this.navigationItems$ = this.store.pipe(select(selectors.navItems));
  }
}
